<template>
    <div class="sprite-animation">
        <img class="bgLight" src="@/assets/theme/light2.png" alt="">
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

const startAnimation = ref(false);

onMounted(() => {
    setTimeout(() => {
        startAnimation.value = true;
    }, 100);
});
</script>

<style scoped>
.bgLight {
    width: 85%;
    animation: rotateBg 5s linear infinite;
}


.sprite-animation {
    width: 400px;
    height: 352px;
    background-image: url('@/assets/theme/final.png');
    animation: sprite 1.5s steps(23) forwards;
    animation-iteration-count: 1;
    scale: 1.2;
}

@keyframes sprite {
    from {
        background-position: 0px;
    }
    to {
        background-position: -9200px; /* Correct last frame position */
    }
}

@keyframes rotateBg {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>
